import React, { useEffect, useState } from "react";
import styles from "./Listas.module.css";
import ModalLista from "../../modales/ModalLista/ModalLista";
import { useDispatch } from "react-redux";
import { crearLista, getListas } from "../../../../actions";
import { formatoLegible, calcularEdad } from "../../../../utils/funciones";
import ojo from "../../../../assets/ojo.png";
import ModalListaDesktop from "../../modales/ModalLista/ModalListaDesktop";
import axios from "axios";
import { URL } from "../../../../link";
import Alert from "../../../Alert/Alert";

const Listas = ({ listas, inVisitor, setShowNavSecond }) => {
  const dataUserLocal = JSON.parse(localStorage.getItem("dataUser"));

  const [addLista, setAddLista] = useState(false);
  const [listaName, setListaName] = useState("");
  const [listaDesc, setListaDesc] = useState("");
  const [verListIndex, setVerListIndex] = useState(null);
  const [modalListaBool, setModalListaBool] = useState(false);
  const [listaEditar, setListaEditar] = useState({});
  const [idLista, setIdLista] = useState("");
  const [allJugadoresList, setAllJugadores] = useState([]);
  const [listaDesktop, setListaDesktop] = useState(null); // Nueva state para el desktop

  const dispach = useDispatch();

  const nuevaLista = async () => {
    const data = {
      nombre: listaName,
      descripcion: listaDesc,
      creadorId: dataUserLocal.id,
    };
    await dispach(crearLista(data));
    await dispach(getListas(dataUserLocal.id));
    setListaName("");
    setListaDesc("");
    setAddLista(false);
  };

  const borrarLista = async () => {
    try {
      const response = await axios.delete(`${URL}/lista/delete/${idLista}`);
      console.log(response);
      await dispach(getListas(dataUserLocal.id));
      setIdLista("");
    } catch (error) {
      console.log(error);
    }
  };

  const editarLista = (index) => {
    setListaEditar(listas[index]);
    setListaDesktop(listas[index]); // También actualizar para desktop
    setModalListaBool(true);
    setShowNavSecond(false);
  };

  const verLista = (index) => {
    setListaDesktop(listas[index]); // Actualizar lista para desktop
    setVerListIndex(index);
  };

  const addJugador = async (jugadorID) => {
    const data = {
      id: listaEditar.id,
      jugadorId: jugadorID,
    };
    try {
      const response = await axios.put(`${URL}/lista/agregar`, data);
      setListaEditar(response.data);
      setListaDesktop(response.data); // Sincronizar con desktop
      dispach(getListas(dataUserLocal.id));
    } catch (error) {
      console.log(error);
    }
  };

  const deleteJugador = async (jugadorID) => {
    const data = {
      id: listaEditar.id,
      jugadorId: jugadorID,
    };
    console.log(data);
    try {
      const response = await axios.put(`${URL}/lista/eliminar`, data);
      console.log(response.data);
      setListaEditar(response.data);
      setListaDesktop(response.data); // Sincronizar con desktop
      dispach(getListas(dataUserLocal.id));
    } catch (error) {
      console.log(error);
    }
  };

  const getJugadores = async () => {
    try {
      const response = await axios.get(`${URL}/usuario/jugadoresByReclutador`);
      setAllJugadores(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getJugadores();
  }, []);

  // Establecer la primera lista por defecto cuando se cargan las listas
  useEffect(() => {
    if (listas.length > 0 && !listaDesktop) {
      setListaDesktop(listas[0]);
    }
  }, [listas, listaDesktop]);

  return (
    <div className={styles.listas}>
      <div className={styles.contTitle}>
        <h2 className={styles.title}>MIS LISTAS</h2>
        <p className={styles.btnTxt} onClick={() => setAddLista(!addLista)}>
          Nuvea lista
        </p>
      </div>
      {addLista && (
        <div className={styles.addLista}>
          <p className={styles.txt}>Nombre de la lista</p>
          <input
            className={styles.inp}
            type="text"
            name="lista"
            id="lista"
            value={listaName}
            onChange={(e) => setListaName(e.target.value)}
          />
          <p className={styles.txt}>Descripcion de la lista</p>
          <input
            className={styles.inp}
            type="text"
            name="descripcion"
            id="descripcion"
            value={listaDesc}
            onChange={(e) => setListaDesc(e.target.value)}
          />
          <div className={styles.botonera}>
            <button
              className={styles.btn}
              onClick={() => setAddLista(!addLista)}
            >
              Cancelar
            </button>
            <button className={styles.btnA} onClick={nuevaLista}>
              Guardar
            </button>
          </div>
        </div>
      )}
      <div className={styles.contListas}>
        {listas.map((lista, index) => (
          <div key={index} className={styles.contLista}>
            <div className={styles.listVista}>
              <div className={styles.listData}>
                <h3 className={styles.listName}>
                  {lista.nombre.toUpperCase()}
                </h3>
                <p className={styles.listDesc}>{lista.descripcion}</p>
              </div>
              <div className={styles.contBtnTxt}>
                {verListIndex === index ? (
                  <p
                    className={styles.btnTxt}
                    onClick={() => setVerListIndex(null)}
                  >
                    Cerrar
                  </p>
                ) : (
                  <p className={styles.btnTxt} onClick={() => verLista(index)}>
                    Ver
                  </p>
                )}
                <p className={styles.btnTxt} onClick={() => editarLista(index)}>
                  Editar
                </p>
                <p
                  className={styles.btnTxt}
                  onClick={() => setIdLista(lista.id)}
                >
                  Borrar
                </p>
              </div>
            </div>
            {verListIndex === index && (
              <div className={styles.verLista}>
                {lista.Usuarios.length > 0 ? (
                  <div className={styles.contList}>
                    {lista.Usuarios.map((jugador, index) => (
                      <div key={index} className={styles.list}>
                        <img className={styles.img} src={jugador.foto} alt="" />
                        <div className={styles.contDataUser}>
                          <p className={styles.name}>{jugador.nombre}</p>
                          <p className={styles.posicion}>
                            {formatoLegible(jugador.posicion)} -{" "}
                            {calcularEdad(
                              jugador.dia,
                              jugador.mes,
                              jugador.anio
                            )}{" "}
                            años
                          </p>
                        </div>
                        <div
                          className={styles.btnAdd}
                          onClick={() => inVisitor(jugador.id)}
                        >
                          <img className={styles.iconB} src={ojo} alt="" />
                        </div>
                        <div className={styles.contBSD}>
                          <p className={styles.bsdTxt}>BSD</p>
                          <p className={styles.bsdValor}>{jugador.score}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={styles.contList}>
                    <h3 className={styles.cuestion}>
                      AGREGA JUGADORES A TU LISTA
                    </h3>
                    <button
                      className={styles.btnC}
                      onClick={() => editarLista(index)}
                    >
                      Agregar
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
        <div className={styles.modalListaFija}>
          <ModalListaDesktop
            setModalListaBool={setModalListaBool}
            modalListaBool={modalListaBool}
            allJugadores={allJugadoresList}
            inVisitor={inVisitor}
            listatReckup={listaDesktop || listas[0]}
            listas={listas}
            addJugador={addJugador}
            deleteJugador={deleteJugador}
          />
        </div>
      </div>
      {modalListaBool && (
        <ModalLista
          setModalListaBool={setModalListaBool}
          modalListaBool={modalListaBool}
          allJugadores={allJugadoresList}
          listatReckup={listaEditar}
          inVisitor={inVisitor}
          addJugador={addJugador}
          deleteJugador={deleteJugador}
          setShowNavSecond={setShowNavSecond}
        />
      )}
      {idLista !== "" && (
        <Alert borrarLista={borrarLista} setIdLista={setIdLista} />
      )}
    </div>
  );
};

export default Listas;
